import axios from "axios";
import { Product } from "../../../models";
import { Filters } from "../../../../../models/filters.model";

export const getRecommendedProducts = (filters: Filters) => {
    return axios.get<Product[]>("products/RecommendedProducts?" + "pickupPointId=" + filters.pickupPointId + "&productName=" + filters.productName + "&categoryId=" + filters.categoryId + "&sortBy=" + filters.sortBy);
}
